<template>
  <div>
      <!-- <div class="rm" :ref="'rm_'+index">
        <div class="rm-form p-30">
          <div v-if="registration_method.registration_method_id==3">
            <div class="row mb-15">
              <input v-model="form.email_address" class="input-text rounded" type="text" placeholder="Email" />
              <label class="text-left d-flex align-items-start" for="email_consent" v-if="portal.template.enable_email_consent">
                <input class="mr-10" id="email_consent" name="email_consent" type="checkbox" v-model="form.consent" />

                <span class="text-16">{{portal.template.consent_text}}</span>
              </label>
            </div>
          </div>
          
          <div class="mb-15">
            <button @click="emitRegistrationMethodData()" class="btn rounded" type="button" :style="'background: ' + color_background_button + '; color: ' + color_text_button">Continue</button>
          </div>
          <p class="text-center text-14 mb-0">
            By clicking continue you agree to the
            <button
              type="button"
              class="text-link"
              @click="selectTermsOfService(index)"
              :aria-expanded="selected_tos === index ? 'true' : 'false'"
              :aria-controls="`tos-panel-${index}`"
            >
              Terms and Conditions
            </button>
          </p>
          <div class="terms-of-service text-left pt-20" v-if="selected_tos==index">
            <div v-html="registration_method.terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
          </div>
        </div>
      </div> -->




      <div class="main-container">
      <!-- Left Side (Hero) -->
      <div class="hero-section">
        <img 
          src="./assets/bg.jpg" 
          alt="Happy team celebrating" 
          class="hero-image"
        />
        <div class="hero-overlay"></div>

        <div class="logo-container">
            <img src="./assets/logo.png" />
        </div>
      </div>

      <!-- Right Side (Content) -->
      <div class="content-section">
        <div class="form-wrapper">
          <div class="headlines">
            <h1 class="headline-main">
              Strong Signal,<br />
              Stronger Team Spirit.
            </h1>
            <p class="headline-sub">
              Get online and stay in the game with our Wifi
            </p>
          </div>

          <form onsubmit="event.preventDefault(); alert('Connecting to WiFi...');" class="login-form">
            <div class="input-group">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                class="form-input"
                v-model="form.first_name"
                required
              />
            </div>
            <div class="input-group">
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                class="form-input"
                v-model="form.last_name"
                required
              />
            </div>
            <div class="input-group">
              <input
                type="email"
                name="email"
                placeholder="Email"
                class="form-input"
                v-model="form.email_address"
                required
              />
            </div>

            <div class="submit-btn-container">
              <button type="submit" class="submit-btn" @click="emitRegistrationMethodData()">
                Get Connected
              </button>
            </div>
            <p class="text-center text-14 mb-0">
            By clicking get get connected you agree to the
              <button
                type="button"
                class="text-link"
                @click="selectTermsOfService(index)"
                :aria-expanded="selected_tos === index ? 'true' : 'false'"
                :aria-controls="`tos-panel-${index}`"
              >
                Terms and Conditions
              </button>
            </p>
            <div class="terms-of-service text-left pt-20" v-if="selected_tos==index">
              <div v-html="registration_method.terms_of_service"></div>
              <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
            </div>
          </form>
        </div>

        <footer class="footer">
          <div class="social-links">
            <a href="https://www.facebook.com/people/Sports-Illustrated-Resorts/61582071763331/" class="social-icon">
              <!-- Facebook Icon -->
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
              </svg>
            </a>
            <a href="https://www.instagram.com/siresorts" class="social-icon">
              <!-- Instagram Icon -->
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line>
              </svg>
            </a>
          </div>
          
          <div class="copyright">
            Sports Illustrated™ is a trademark of ABG SI LLC. ©2025 ABG SI LLC. All rights reserved.
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'registration_method',
  props: ['index','portal','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      // access_code: null,
      access_code_valid: true,
      access_code_error_text: 'Required',
      clicked: false,
      property_select: {
        selected: null,
        warn: false,
      },
      form: {
        first_name:'',
        last_name: '',
        email_address: '',
        consent: false,
        optin_default: 0
      },
    }
  },
  watch: {

  },
  mounted(){
    this.form.consent = this.portal.template.optin_default
  },
  methods: {
    // Send selected Registration Method back to parent
    selectRegistrationMethod:function(index){
      this.$emit('changeSelected', index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },
    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData:function(){
     if(this.registration_method.registration_method_id==3 && !this.form.email_address.trim()) {
        return;
      } 

      const emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: this.registration_method.id,
        ...(!!this.form.last_name && { last_name: this.form.last_name } ),
        ...(!!this.form.first_name && { first_name: this.form.first_name } ),
        ...(!!this.form.email_address && { email_address: this.form.email_address } ),
        ...(this.form.consent && { email_opt_in: 1 } ),
      }

      this.$emit('emitRegistrationMethodData', emitted);
    },

  }
}
</script>
<style>
  #app {padding: 0;}
  :root {
    --si-red: #EF3340;
    --si-red-hover: #d6202d;
    --black: #000000;
    --white: #ffffff;
    --gray-light: #e5e7eb;
    --gray-text: #1f2937;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'Inter', sans-serif;
    background-color: var(--white);
    color: var(--black);
    -webkit-font-smoothing: antialiased;
  }

  /* Layout */
  .main-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
    overflow-x: hidden;
  }

  @media (min-width: 1024px) {
    .main-container {
      flex-direction: row;
    }
  }

  /* Left Side (Hero) */
  .hero-section {
    width: 100%;
    height: 30rem; /* 64px * 4 = 256px approx */
    position: relative;
    flex-shrink: 0;
    background-color: var(--gray-light);
    overflow: hidden;
  }

  @media (min-width: 1024px) {
    .hero-section {
      width: 40%;
      height: 16rem;
      min-height: 100vh;
    }
  }

  .hero-image {
    position: absolute;
    top: 0;
    left: -20%;
    width: 120%;
    height: 140%;
    object-fit: cover;
    object-position: center;
  }

  @media (min-width:  1024px) {
    .hero-image {
      height: 100%;
    }
  }

  .hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.05);
  }

  /* Logo Styles */
  .logo-container {
    position: absolute;
    top: 2rem;
    z-index: 10;
  }

  .logo-container img {
    width:  30%;
    min-width: 200px;
  }

  @media (min-width: 1024px) {
    .logo-container {
      top: 3rem;
      left: 3rem;
    }

    .logo-container img {
      width: 60%;
    }
  }

  .logo-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1;
  }

  .logo-main {
    font-weight: 900;
    font-size: 2.25rem;
    text-transform: uppercase;
    letter-spacing: -0.05em;
    color: var(--si-red);
    text-shadow: 0 1px 2px rgba(0,0,0,0.1);
  }

  @media (min-width: 1024px) {
    .logo-main {
      font-size: 3rem;
    }
  }

  .logo-sub {
    margin-top: -0.125em; /* Closer to line above */
    position: relative;
  }

  .trademark {
    font-size: 0.75rem;
    vertical-align: top;
    margin-left: 0.25rem;
    color: var(--black);
    font-weight: 400;
  }

  .logo-resorts {
    font-weight: 300;
    font-size: 1.875rem;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    color: var(--black);
    margin-top: 0.25rem;
  }

  @media (min-width: 1024px) {
    .logo-resorts {
      font-size: 2.25rem;
    }
  }

  /* Right Side (Form) */
  .content-section {
    width: 100%;
    min-height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media (min-width: 1024px) {
    .content-section {
      width: 60%;
      min-height: 100vh;
    }
  }

  .form-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 3rem 2rem;
    width: 100%;
    max-width: 42rem;
    margin: 0 auto;
  }

  @media (min-width: 1024px) {
    .form-wrapper {
      padding: 3rem 4rem;
    }
  }

  .headlines {
    text-align: center;
    margin-bottom: 2.5rem;
  }

  .headline-main {
    font-size: 1.875rem;
    font-weight: 900;
    text-transform: uppercase;
    line-height: 1.1;
    letter-spacing: -0.025em;
    margin-bottom: 1rem;
  }

  @media (min-width: 1024px) {
    .headline-main {
      font-size: 3rem;
    }
  }

  .headline-sub {
    font-size: 1.125rem;
    color: var(--gray-text);
    font-weight: 500;
  }

  /* Form Elements */
  .login-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  .input-group {
    position: relative;
    width: 100%;
  }

  .form-input {
    width: 100%;
    padding: 1rem 1.5rem;
    border-radius: 9999px; /* Pill shape */
    border: 2px solid var(--black);
    font-size: 1.125rem;
    outline: none;
    transition: all 0.2s ease;
    font-family: inherit;
  }

  .form-input::placeholder {
    color: var(--gray-text);
    opacity: 0.8;
  }

  .form-input:focus {
    border-color: var(--si-red);
    box-shadow: 0 0 0 2px rgba(239, 51, 64, 0.2);
  }

  .submit-btn-container {
    padding-top: 1rem;
  }

  .submit-btn {
    width: 100%;
    background-color: var(--si-red);
    color: var(--white);
    font-weight: 700;
    font-size: 1.25rem;
    padding: 1rem;
    border-radius: 9999px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border: none;
    cursor: pointer;
    transition: transform 0.1s, background-color 0.2s, box-shadow 0.2s;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }

  .submit-btn:hover {
    background-color: var(--si-red-hover);
    transform: scale(1.02);
  }

  .submit-btn:active {
    transform: scale(0.98);
  }

  /* Footer */
  .footer {
    background-color: var(--black);
    color: var(--white);
    padding: 3rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
  }

  .social-links {
    display: flex;
    gap: 1.5rem;
  }

  .social-icon {
    background-color: var(--si-red);
    padding: 0.75rem;
    border-radius: 50%;
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s, color 0.2s;
    text-decoration: none;
  }

  .social-icon:hover {
    background-color: var(--white);
    color: var(--si-red);
  }

  .copyright {
    font-size: 0.625rem;
    color: #9ca3af;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    line-height: 1.5;
    max-width: 32rem;
  }
</style>
